import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import {
  navActivateNextStep, navBack,
  navFinishInstallation,
  navOpenManualInstall,
  navSetActiveStep,
  navToB2B,
  navUpdate
} from './navigation_actions_creator';
import { Store } from '@ngrx/store';
import { NavigationEffectsService } from './navigation_effects.service';
import { REDCRSS_EVENTS } from '../../../../shared/services/constants/redcross_evemts';
import { concatMap, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Injectable()
export class NavigationEffects {

  updateState = createEffect(() => this.action$.pipe(
    ofType(navUpdate),
    concatMap(action => of(action).pipe(withLatestFrom(this.store$))),
    map(([_, state]) => {
      let navigationState = state['app']['install']['navigation'];
      let activeStep = navigationState.navigationItems.filter((item) => item.active === true)[0];
      return navSetActiveStep({activeStep: activeStep});
    })));

  setActiveStep = createEffect(() => this.action$.pipe(
    ofType(navSetActiveStep),
    map((action: any) => {
      let activeStep = action.activeStep;
      this.navigationEffectsService.navigateToStep(activeStep);
    })),
    {
      dispatch: false
    });

  setNextStep = createEffect(() => this.action$.pipe(
    ofType(navActivateNextStep),
    map((action: any) => {
      let activeStep = action.finishedStep;
      this.navigationEffectsService.setStepFeatureSettings(activeStep);
      let nextStep = action.payload.getNextStep();
      return navSetActiveStep(nextStep);
    })));

  navigateToB2B = createEffect(() => this.action$.pipe(
    ofType(navToB2B),
    map(() => {
        this.navigationEffectsService.navigateToB2B();
    })),
    {
      dispatch: false
    });

  finishInstallation = createEffect(() => this.action$.pipe(
    ofType(navFinishInstallation),
      concatMap(action => of(action).pipe(withLatestFrom(this.store$))),
      mergeMap(([_, state]) => {
        let mapState = state['app']['install']['map'];
        let widgetState = state['app']['install']['widget'];

        if (mapState.doneInstallation === true && widgetState.doneInstallation === true) {
          this.redCrossService.track(REDCRSS_EVENTS.ONBOARDING_COMPLETED, {
            category: 'Reviews'
          });
        }

        return this.navigationEffectsService.setFinishInstallationSettings();
    })),
    {
      dispatch: false
    });

  navigateToManualInstall = createEffect(() => this.action$.pipe(
    ofType(navOpenManualInstall),
    map(() => {
        this.navigationEffectsService.navigateToManualInstall();
    })),
    {
      dispatch: false
    });

  navigateToIntegrateMainScreen = createEffect(() => this.action$.pipe(
    ofType(navBack),
    map(() => {
        this.navigationEffectsService.navigateToIntegrateMainScreen();
    })),
    {
      dispatch: false
    });

  constructor(
    private action$: Actions,
    private store$: Store,
    private redCrossService: AnalyticsTrackingProvider,
    private navigationEffectsService: NavigationEffectsService) { }
}
